export let MEDIA_STATUSES = /*#__PURE__*/function (MEDIA_STATUSES) {
  MEDIA_STATUSES["IN_QUEUE"] = "IN-QUEUE";
  MEDIA_STATUSES["PENDING"] = "PENDING";
  MEDIA_STATUSES["INPROGRESS"] = "INPROGRESS";
  MEDIA_STATUSES["READY"] = "READY";
  MEDIA_STATUSES["FAILED"] = "FAILED";
  return MEDIA_STATUSES;
}({});
//# sourceMappingURL=media-statuses.js.map